import { render, staticRenderFns } from "./PannelThree.vue?vue&type=template&id=4a9310b8&scoped=true&"
import script from "./PannelThree.vue?vue&type=script&lang=js&"
export * from "./PannelThree.vue?vue&type=script&lang=js&"
import style0 from "./PannelThree.vue?vue&type=style&index=0&id=4a9310b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9310b8",
  null
  
)

export default component.exports